var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Cookies from 'js-cookie';
import defaultPreferencesDialogTemplate from '../consts/default-preferences-template';
var saveCustomPreferences = function (value) {
    if (value === void 0) { value = null; }
    var forcePreferences = Cookies.get('force-segment') === 'true';
    return defaultPreferencesDialogTemplate.categories.reduce(function (acc, cur) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[cur.key] = forcePreferences || value, _a)));
    }, {});
};
export default saveCustomPreferences;
